module.exports = __webpack_public_path__ + "2abf5fa3fba5191023698b08f754cf62.svg";